$('.tabs-hover a').hover(function () {
    $(this).tab('show');
});

var clicktag = 0;
$(".menu-button").click(function () {
    if (clicktag == 0) {
        clicktag = 1;
        $(this).toggleClass("cross");
        $(".nav-down").slideUp("slow");
        $(".nav-click").removeClass("active");
        if ($(".nav-box").is(":hidden")) {
            $(".nav-box").slideDown("slow");
        } else {
            $(".nav-box").slideUp("slow");
        }
        setTimeout(function () {
            clicktag = 0
        }, 700);
    }
});

$(".nav-click").click(function () {
    if ($(this).parents("li").find(".nav-down").is(":hidden")) {
        $(this).parents("li").find(".nav-down").slideDown("slow");
        $(this).addClass("active");
    } else {
        $(this).parents("li").find(".nav-down").slideUp("slow");
        $(this).removeClass("active");
    }
});
$(".list-left-top-phone").click(function () {
    if ($(".list-left-nav").is(":hidden")) {
        $(".list-left-nav").slideDown("slow");
    } else {
        $(".list-left-nav").slideUp("slow");
    }
});
$(".down-a").click(function () {
    $(".left-li").removeClass("active");
    $(".left-nav-down").slideUp("slow");
    if ($(this).parents("li").find(".left-nav-down").is(":hidden")) {
        $(this).parents("li").addClass("active");
        $(this).parents("li").find(".left-nav-down").slideDown("slow");
    } else {
        $(this).parents("li").removeClass("active");
        $(this).parents("li").find(".left-nav-down").slideUp("slow");
    }
});
$(".list-left-tt-phone").click(function () {
    if ($(".left-nav").is(":hidden")) {
        $(".left-nav").slideDown("slow");
    } else {
        $(".left-nav").slideUp("slow");
    }
});
window.onload = function () {
    if ($(window).scrollTop() <= 1) {
        $('.header').removeClass('one');
    } else if ($(window).scrollTop() > 1) {
        $('.header').addClass('one');
    }
}
$(window).scroll(function () {
    if ($(window).scrollTop() <= 1) {
        $('.header').removeClass('one');
    } else if ($(window).scrollTop() > 1) {
        $('.header').addClass('one');
    }
})
$(".search-a").click(function () {
    $("#search").addClass("showdiv");

});
$(".close").click(function () {
    $("#search").removeClass("showdiv");

});

$(document).ready(function () {
    // 配置参数
    let normInterval = 1800;
    var tabConfig = {
        normalInterval: normInterval,     // 正常轮播3秒
        hoverInterval: 15000,     // 桌面悬停15秒
        mobileTouchInterval: normInterval,// 移动端触摸保持时的安全间隔
        currentInterval: normInterval,
        isMobile: false,
        touchHoldTimer: normInterval      // 触摸保持计时器
    };

  // 移动端检测（优化版）
  function checkMobile() {
    return ('ontouchstart' in window) ||
           (window.matchMedia("(max-width: 768px)").matches);
  }

  // 初始化标签页
  initAutoTabs('.page-three');
  initAutoTabs('.page-four');

  function initAutoTabs(pageClass) {
    var $tabNav = $(pageClass + ' .tabs-ul');
    var $tabContent = $(pageClass + ' .container');
    var $tabContentV1 = $(pageClass + ' .tab-content');
    var $tabs = $tabNav.find('[data-toggle="tab"]:not(.hui)');
    var currentIndex = 0;
    var interval;
    var isTouching = false; // 触摸状态标志

    // 设备检测
    tabConfig.isMobile = checkMobile();

    // 启动轮播（带安全检测）
    function startAutoPlay() {
      stopAutoPlay();
      // 如果正在触摸且是移动端，使用更长间隔
      let useInterval = isTouching ? tabConfig.mobileTouchInterval : getCurrentInterval();
      console.log(`interval :${useInterval}`);
      interval = setInterval(autoPlay, useInterval);
    }

    // 停止轮播
    function stopAutoPlay() {
      clearInterval(interval);
      clearTimeout(tabConfig.touchHoldTimer);
    }

    // 获取适用的间隔时间
    function getCurrentInterval() {
      return tabConfig.isMobile ? tabConfig.normalInterval : tabConfig.currentInterval;
    }

    // 自动切换逻辑
    function autoPlay() {
      currentIndex = (currentIndex + 1) % $tabs.length;
      $tabs.eq(currentIndex).tab('show');
    }

    // 初始化
    startAutoPlay();

    // 移动端触摸控制
    if (tabConfig.isMobile) {
      $tabContent.on('touchstart', function(e) {
        isTouching = true;
        stopAutoPlay();
        console.log("torch start");

        // 设置触摸保持超时（2秒后恢复轮播）
        tabConfig.touchHoldTimer = setTimeout(function() {
          isTouching = false;
          startAutoPlay();
        }, 10000);
      });

      $tabContent.on('touchend touchcancel', function() {
        clearTimeout(tabConfig.touchHoldTimer);
        isTouching = false;
        console.log("torch end");
        startAutoPlay();
      });
    }

    // 桌面端悬停逻辑
    if (!tabConfig.isMobile) {
        // 悬停时切换为慢速轮播
        $tabNav.add($tabContentV1).hover(
          function() {
            tabConfig.currentInterval = tabConfig.hoverInterval;
            startAutoPlay(); // 重新启动以应用新间隔
          },
          function() {
            tabConfig.currentInterval = tabConfig.normalInterval;
            startAutoPlay(); // 恢复常规速度
          }
        );
    }

    // 监听标签切换事件（Bootstrap 3事件）
    $tabNav.on('shown.bs.tab', 'a[data-toggle="tab"]', function(e) {
      currentIndex = $tabs.index(e.target);
    });

    // 响应式重置
    $(window).on('resize', function() {
      var wasMobile = tabConfig.isMobile;
      tabConfig.isMobile = checkMobile();
      if (wasMobile !== tabConfig.isMobile) {
        stopAutoPlay();
        startAutoPlay();
      }
    });
  }
});